// ✅ 改為匯入 alertService 模組
import {
  showSuccess,
  showError,
  showToast,
} from "@/assets/js/utils/alertService.js";
import api from "@/assets/js/utils/api.js";
import { DateHelper } from "@/assets/js/utils/time";

export default {
  name: "CarouselManagement",

  data() {
    return {
      showModal: false,
      showPreviewModal: false,
      editingCarousel: null,
      previewImage: "",
      previewTitle: "",
      previewSubtitle: "",
      formData: {
        title: "",
        subtitle: "",
        link: "",
        active: true,
        image: null,
        imagePreview: null,
        startTime: "",
        endTime: "",
      },
      carousels: [],
    };
  },

  computed: {
    activeCarousels() {
      return this.carousels.filter((c) => c.IsActive).length;
    },
    inactiveCarousels() {
      return this.carousels.filter((c) => !c.IsActive).length;
    },
  },

  methods: {
    async loadCarousels() {
      try {
        const res = await api.get("/banner/list");
        if (res.data.success) {
          this.carousels = res.data.data.map((x) => ({
            Id: x.Id,
            Name: x.Name,
            Description: x.Description,
            ImageUrl: x.ImageUrl || require("@/assets/image/AYH.png"),
            IsActive: x.IsActive,
            CreateDate: x.CreateDate,
            UpdateDate: x.UpdateDate,
            StartTime: x.StartTime,
            EndTime: x.EndTime,
          }));
        } else {
          showError(res.data.message);
        }
      } catch (err) {
        showError("載入輪播資料失敗");
      }
    },
    openAddModal() {
      this.editingCarousel = null;
      this.formData = {
        title: "",
        subtitle: "",
        link: "",
        active: true,
        image: null,
        imagePreview: null,
        startTime: "",
        endTime: "",
      };
      this.showModal = true;
    },

    editCarousel(carousel) {
      this.editingCarousel = carousel;
      this.formData = {
        title: carousel.Name,
        subtitle: carousel.Description,
        link: "",
        active: carousel.IsActive,
        image: null,
        imagePreview: carousel.ImageUrl,
        startTime: this.formatInputDate(carousel.StartTime),
        endTime: this.formatInputDate(carousel.EndTime),
      };
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.editingCarousel = null;
    },

    triggerFileInput() {
      this.$refs.imageInput.click();
    },

    handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (file.size > 2 * 1024 * 1024) {
        showError("圖片檔案不能超過 5MB");
        return;
      }

      const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
      if (!validTypes.includes(file.type)) {
        showError("只接受 JPG、JPEG、PNG、WebP 格式");
        return;
      }

      this.formData.image = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.formData.imagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    async saveCarousel() {
      try {
        if (!this.formData.title) {
          showError("請輸入標題");
          return;
        }

        // 🟡 時間檢查（使用 ISO 格式比較最安全）
        const start = this.formData.startTime
          ? new Date(this.formData.startTime)
          : null;
        const end = this.formData.endTime
          ? new Date(this.formData.endTime)
          : null;

        // ❗未填時間
        if (!start || !end) {
          showError("請輸入完整的活動開始與結束時間");
          return;
        }

        // ❗結束時間<=開始時間
        if (end <= start) {
          showError("結束時間不可小於或等於開始時間");
          return;
        }

        const formData = new FormData();

        // 🔹後端要求 banner(JSON)
        const bannerObj = {
          Id: this.editingCarousel.Id,
          Name: this.formData.title,
          Description: this.formData.subtitle,
          IsActive: this.formData.active,
          StartTime: this.formData.startTime,
          EndTime: this.formData.endTime,
        };

        formData.append("banner", JSON.stringify(bannerObj));

        // 🔹如果有重新選圖片才附加 file
        if (this.formData.image) {
          formData.append("file", this.formData.image);
        }

        const res = await api.post("/banner/add", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (res.data.success) {
          showSuccess(res.data.message);
          await this.loadCarousels();
          this.closeModal();
        } else {
          showError(res.data.message);
        }
      } catch (error) {
        console.error(error);
        showError("更新輪播失敗");
      }
    },

    removeImage() {
      this.formData.image = null;
      this.formData.imagePreview = null;
      if (this.$refs.imageInput) this.$refs.imageInput.value = "";
    },

    async toggleActive(carousel) {
      try {
        const formData = new FormData();

        const bannerObj = {
          Id: carousel.Id,
          Name: carousel.Name,
          Description: carousel.Description,
          IsActive: !carousel.IsActive,
        };

        formData.append("banner", JSON.stringify(bannerObj));

        // 🚫 不更新圖片 → 就不要 append file
        // 只更新狀態 OK

        const res = await api.post("/banner/add", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (res.data.success) {
          carousel.IsActive = !carousel.IsActive;
          carousel.UpdateDate = new Date().toISOString();
          showToast(
            `輪播圖已${carousel.IsActive ? "啟用" : "停用"}！`,
            "success"
          );
        } else {
          showError(res.data.message);
        }
      } catch (err) {
        showError("更新狀態失敗");
      }
    },
    previewCarousel(carousel) {
      this.previewImage = carousel.ImageUrl; // 控制圖片
      this.previewTitle = carousel.Name; // 控制主標題
      this.previewSubtitle = carousel.Description; // 控制副標題(可為空)
      this.showPreviewModal = true;
    },

    formatDate(dateString) {
      return DateHelper.toTaiwanFormat(dateString);
    },

    formatInputDate(dateString) {
      // 控制input格式
      if (!dateString) return "";
      return dateString.substring(0, 16); // 2025-01-30T14:20
    },
  },

  async mounted() {
    await this.loadCarousels();
  },
};
